import { PaymentMethod } from '@stripe/stripe-js'
import { UserSettings } from '../store'
import ApiExtension from './api-extension'

type UserUpdate = {
  settings: UserSettings
}

export default class User extends ApiExtension {
  defaultPaymentMethod(): Promise<PaymentMethod> {
    return this.fetch('default_payment_method_users', {})
  }

  getPurchaseUrl(
    productId: string,
    currency: string,
    successUrl?: string,
    cancelUrl?: string
  ): string {
    return this.createUrl(
      'begin_purchase_user_product',
      { id: productId },
      {
        queryParams: {
          currency,
          success_url: successUrl,
          cancel_url: cancelUrl,
        },
      }
    )
  }

  update(update: Partial<UserUpdate>) {
    return this.fetch('user_index', {}, { method: 'PUT', body: update })
  }

  lock(userId: number) {
    return this.fetch('lock_admin_user', { id: userId })
  }

  unlock(userId: number) {
    return this.fetch('unlock_admin_user', { id: userId })
  }
}
